import React from "react";
import { useSelector } from "react-redux";

import RestaurantHeader from "./RestaurantHeader";
import Body from "./Body";
import { sendEvent } from '../../../../../utils/amplitude';


function Restaurant(props) {
  const restaurantName = useSelector(state => state.companyConfig.name);
  const companyId = useSelector(state => state.companyConfig.company_id);
  const amplId = useSelector(state => state.companyConfig.amplId);
  const verticalId = useSelector(state => state.companyConfig.vertical_id);

  sendEvent(amplId, 'Menu_Loaded', {
    'customer': restaurantName,
    'customerId': companyId,
    'vertical': verticalId,
    'page': 'menu',
  });

  return (
    <div className="restaurant-menu-wrapper">
      <RestaurantHeader />
      <div className="restaurant-menu-body-wrapper">
        <Body />
      </div>
    </div>
  );
}

export default Restaurant;
